export const NewsletterPeriodicity = {
  Daily: 'daily',
  Weekly: 'weekly',
  Monthly: 'monthly',
} as const

export type NewsletterPeriodicityValue =
  (typeof NewsletterPeriodicity)[keyof typeof NewsletterPeriodicity]
